import React from 'react';
import Link from 'next/link';
import classNames from 'classnames/bind';
import { LinksGroup, LinkType } from 'components/Footer/Footer.types';
import styles from 'components/Footer/LinksList/LinksList.module.scss';

const cn = classNames.bind(styles);

interface LinksListProps {
  linksGroup: LinksGroup;
};

const LinksList = ({ linksGroup }: LinksListProps) => {
  const links = linksGroup.links.map((item: LinkType) => {
    return (
      <li
        className={cn('links-list__item')}
        key={item.linkId}
      >
        {item.linkUrl ? (
          <Link
            className={cn('links-list__item-link')}
            href={item.linkUrl}
          >
            {item.linkLabel}
          </Link>
        ) : (
          <span className={cn('links-list__item-link', 'no-hover')}>{item.linkLabel}</span>
        )}
      </li>
    );
  });

  return <ul className={cn('links-list')}>{links}</ul>;
};

export { LinksList };
